
import { Link } from "react-router-dom";
import styled from "styled-components";
import AccessibleForwardIcon from '@mui/icons-material/AccessibleForward';
import { Badge, IconButton } from "@mui/material";
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import { useEffect, useState } from "react";
import profile from "../../assets/images/profile.png"
import Avatar from '@mui/material/Avatar';
import { connect } from "react-redux";
import { useBreakpoint } from "react-use-size";
import AccountMenu from "../../componentExternal/accountMenu";
import CodeMenu from "../../componentExternal/codeMenu";
import { Sidebar } from "primereact/sidebar";
import Side_Bar from "./components/sidebar";
import Drawer from '@mui/material/Drawer';
import { SnackbarProvider, useSnackbar } from 'notistack';
//api requests
import apiRoutes from "../../apiRoutes";
import { Helper } from '../../tools/helper';
import { change_balance, get_cart, notification_Cart } from '../../redux/action';
import { useNavigate } from 'react-router-dom';
import MessagesMenu from "../../componentExternal/messagesMenu";
import NotificationMenu from "../../componentExternal/notificationMenu";

const MarqueeBox = styled(Box)`
    background:${props=> props.theme.colors.main.default};
    height:39px;
    width:60px;
    padding:4px 3px;
    border-radius: 4px; 
    color:white;
    display:flex;
    justify-content:center;
    align-items:center;
    &:hover{
        cursor: pointer;
    },
    @media(max-width:400px):{
        font-size:11px;
        width:35px;
        height:30px;

    }
}
`
const List = styled.ul`
    display:flex;
    width:100%;
    justify-content:end;
    gap:30px;
    list-style:none;
    @media(max-width:768px){
        gap:2px;
    };
    @media(min-width:769px) and (max-width:1200px){
        gap:0.5px;
    };
    @media(min-width:1201px) {
        gap:6px;
    }
`
const ListHref = styled.ul`

    list-style:none;
`

const ItemList = styled.li`
    display:flex;
    align-items:center;
    color: var(--Text, #161616);
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 30px;
    cursor:pointer;
    transition: 0.5s;
   
    
`
const Icon = styled.span`
    
    
`
const IconFooter = styled.span`
    margin-right: 10px;
    margin-top:10px;
`
const LinkFooter = styled.span`

    margin-right: 10px;
    margin-top:10px;
    color: white!important;  
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
    &:hover:{
        color: #9f6abb!important;
    }


`

const Button = styled.button`
    background: ${props=> props.theme.colors.main.default};
    display: flex;  
    padding: 10px 18px 10px 10px;
    justify-content: center;
    align-items: center;
    gap: 5px;
    color: var(--BG, #FFF);
    font-family: Poppins;
    font-size: clamp(0.7rem, 0.29vw + 0.56rem, 0.9rem);
    font-style: normal;
    font-weight: 500 !important;
    line-height: 22px;
    cursor:pointer;
    border-radius:4px;
    border:none;
    transition :0.8s;
    &:hover {
        background-color: ${props=>props.theme.colors.main.complemently};
        
      }
    @media(max-width : 550px){
        width: 60px;
        padding: 6px 4px;
        gap:5px;
        // font-size: 14px;
    }
    @media (min-width:550px) {
        width: 95px;
    }
`


function MDMenu({data,isOpen,isNav=true,onClick,username,number,photo,cart_with_api,cart_number,number_Redux,balance_redux,change_balance}) {
    const smallSize = useBreakpoint(993)
    const isSoSmall = useBreakpoint(600)
    const isSmallForButtons = useBreakpoint(550)
    const [isDrower,setIsDrower] = useState(false)
    const [number_cart, setNumber_cart] = useState(0)
    const navigate = useNavigate()
    const [balance, setBalance] = useState(0)
    const [user,setUser] = useState({
        username:"",
        photo:""
    })
    useEffect(()=>{
        setIsDrower(isOpen) 
    },[isOpen])
    useEffect(()=>{
        setBalance(balance_redux) 
    },[balance_redux])
    useEffect(()=>{
        if(localStorage.hasOwnProperty("number_cart")){
            setNumber_cart(JSON.parse(localStorage.getItem("number_cart")))
        }else{
            setNumber_cart(0)
        }  
    },[number_Redux])
    useEffect(()=>{
        const controller = new AbortController()
        const signal = controller.signal
        if(localStorage.hasOwnProperty("user") && username == "" && photo==null){
            setUser({
                username:JSON.parse(localStorage.getItem("user")).username,
                photo:JSON.parse(localStorage.getItem("user")).photo?
                JSON.parse(localStorage.getItem("user")).photo:profile
            })
            get_cart(signal,JSON.parse(localStorage.getItem("user")).id)
        }else{
            setUser({
                username:username,
                photo:photo
            })
        }
        return ()=>{
            controller.abort()
        }
    },[username,photo])
    const get_cart = async(signal,id) =>{
        const { response, message } = await Helper.Get_Abort({
            url: apiRoutes.checkout.view_cart,
            hasToken:true,
            signal:signal,
            data:{user_id : id}
        })
        if(response){
            setBalance(response.data.balance)
            change_balance(response.data.balance)
            cart_number(response.data.products.length)
            localStorage.setItem("number_cart",response.data.products.length)
            cart_with_api(response.data,response.data.balance)
            // setIsLoading(false)
        }
    }
    
    return ( isNav?<List>
        {/* {!smallSize&& */}
        <ItemList >  
            <CodeMenu/>    
        </ItemList>
        {/* } */}
        
        {localStorage.hasOwnProperty("user")&&<MessagesMenu/>}
        
        {localStorage.hasOwnProperty("user")&&data.map((e,index)=>{
            if(e.name=="Cart"){
                return<ItemList key={`Menu_${e.name}`}>
                <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center'}}>
                    <Tooltip  title={e.name} >
                        {/* <IconButton 
                        sx={{padding:"0 !important"}}
                        size="small"
                        
                        > */}
                        
                            <Box onClick={()=>{setIsDrower(!isDrower)}}
                                sx={isSoSmall?{background:"white",    display: "flex",
                                alignItems: "center",
                                justifyContent: "center",borderRadius:"unset !important",
                                "& .path-nav-fill":{
                                    fill:"grey",
                                    transition:"0.3s"
                                },
                                "&:hover":{
                                    "& .path-nav-fill":{
                                        fill:"#D80621"
                                    }
                                } 
                            
                            }:{background:"white",borderRadius:"unset !important",  display: "flex",
                                alignItems: "center",

                                justifyContent: "center", width: 32, height: 32,
                                "& .path-nav-fill":{
                                    fill:"grey",
                                    transition:"0.3s"
                                },
                                "&:hover":{
                                    "& .path-nav-fill":{
                                        fill:"#D80621"
                                    }
                                } }}>
                            <Badge color="error" badgeContent={number_cart}>
                            {/* <svg style={{marginTop:"-2px"}} xmlns="http://www.w3.org/2000/svg" width={isSoSmall?"18":"24"} height={isSoSmall?"18":"24"} viewBox="0 0 24 24" fill="none">
                                    <Path d="M5.22977 14.013L5.95838 13.8352L5.22977 14.013ZM5.22977 8.71362L4.50116 8.53578L5.22977 8.71362ZM20.1816 8.71363L20.9102 8.53578V8.53578L20.1816 8.71363ZM20.1816 14.013L20.9102 14.1909L20.1816 14.013ZM15.2447 18.5967L15.0798 17.8651L15.2447 18.5967ZM10.1666 18.5967L10.0017 19.3284H10.0017L10.1666 18.5967ZM10.1666 4.12989L10.3316 4.86154L10.1666 4.12989ZM15.2447 4.12989L15.4096 3.39825V3.39825L15.2447 4.12989ZM9.71943 18.4959L9.88435 17.7643L9.88435 17.7643L9.71943 18.4959ZM15.6919 18.4959L15.8568 19.2276H15.8568L15.6919 18.4959ZM15.6919 4.2307L15.527 4.96234V4.96234L15.6919 4.2307ZM9.71943 4.2307L9.5545 3.49906L9.71943 4.2307ZM6.07315 5.61107L5.33541 5.74609L6.07315 5.61107ZM5.46979 6.48034C5.54435 6.88779 5.9351 7.15764 6.34255 7.08307C6.75 7.00851 7.01985 6.61776 6.94528 6.21031L5.46979 6.48034ZM3.63181 2.26167C3.22404 2.18888 2.83447 2.46042 2.76167 2.86819C2.68888 3.27596 2.96042 3.66553 3.36819 3.73833L3.63181 2.26167ZM9.17092 18.8331C9.2458 18.9941 9.27487 19.1753 9.25344 19.3546L10.7428 19.5327C10.7972 19.0778 10.7241 18.6158 10.531 18.2006L9.17092 18.8331ZM9.25344 19.3546C9.23201 19.5338 9.16138 19.7007 9.0526 19.836L10.2215 20.776C10.5085 20.4192 10.6884 19.9875 10.7428 19.5327L9.25344 19.3546ZM9.0526 19.836C8.94398 19.9711 8.80246 20.0685 8.64656 20.1199L9.11662 21.5443C9.55163 21.4008 9.93443 21.133 10.2215 20.776L9.0526 19.836ZM8.64656 20.1199C8.49086 20.1713 8.32484 20.1756 8.16715 20.1326L7.77249 21.5798C8.21464 21.7003 8.68141 21.688 9.11662 21.5443L8.64656 20.1199ZM8.16715 20.1326C8.00929 20.0896 7.86365 20 7.74891 19.8714L6.62941 20.8698C6.93436 21.2117 7.33051 21.4592 7.77249 21.5798L8.16715 20.1326ZM7.74891 19.8714C7.63399 19.7425 7.55531 19.58 7.52502 19.4024L6.04634 19.6544C6.12331 20.106 6.32465 20.528 6.62941 20.8698L7.74891 19.8714ZM7.52502 19.4024C7.49473 19.2246 7.51468 19.042 7.58163 18.8768L6.19149 18.3133C6.01945 18.7377 5.96939 19.2028 6.04634 19.6544L7.52502 19.4024ZM7.58163 18.8768C7.64853 18.7117 7.75861 18.5731 7.89583 18.4752L7.02418 17.2544C6.6515 17.5205 6.36359 17.8887 6.19149 18.3133L7.58163 18.8768ZM17.428 18.6178C17.5565 18.7305 17.6535 18.8813 17.7043 19.0537L19.1431 18.6298C19.0133 18.1891 18.7623 17.7929 18.417 17.4901L17.428 18.6178ZM17.7043 19.0537C17.7551 19.2263 17.7568 19.4108 17.709 19.5844L19.1552 19.9826C19.2771 19.5397 19.273 19.0705 19.1431 18.6298L17.7043 19.0537ZM17.709 19.5844C17.6612 19.758 17.5668 19.9107 17.4402 20.0259L18.4497 21.1354C18.7894 20.8262 19.0332 20.4256 19.1552 19.9826L17.709 19.5844ZM17.4402 20.0259C17.3137 20.141 17.1604 20.2141 16.9991 20.2397L17.2344 21.7212C17.6883 21.6491 18.1098 21.4447 18.4497 21.1354L17.4402 20.0259ZM16.9991 20.2397C16.838 20.2653 16.6726 20.2429 16.5218 20.174L15.8984 21.5383C16.3164 21.7294 16.7804 21.7933 17.2344 21.7212L16.9991 20.2397ZM16.5218 20.174C16.3708 20.105 16.2389 19.9912 16.1442 19.8432L14.8805 20.6513C15.1281 21.0384 15.4805 21.3474 15.8984 21.5383L16.5218 20.174ZM16.1442 19.8432C16.0493 19.6949 15.9967 19.5196 15.9947 19.3383L14.4947 19.3551C14.4999 19.8145 14.633 20.2644 14.8805 20.6513L16.1442 19.8432ZM15.9947 19.3383C15.9926 19.1569 16.0413 18.9803 16.1329 18.8295L14.8511 18.0504C14.6126 18.4429 14.4896 18.8957 14.4947 19.3551L15.9947 19.3383ZM9.88435 4.96234L10.3316 4.86154L10.0017 3.39825L9.5545 3.49906L9.88435 4.96234ZM15.0798 4.86154L15.527 4.96234L15.8568 3.49906L15.4096 3.39825L15.0798 4.86154ZM15.527 17.7643L15.0798 17.8651L15.4096 19.3284L15.8568 19.2276L15.527 17.7643ZM10.3316 17.8651L9.88435 17.7643L9.5545 19.2276L10.0017 19.3284L10.3316 17.8651ZM5.95838 13.8352C5.56232 12.2126 5.56232 10.514 5.95838 8.89147L4.50116 8.53578C4.04806 10.392 4.04806 12.3346 4.50116 14.1909L5.95838 13.8352ZM19.453 8.89148C19.849 10.514 19.849 12.2126 19.453 13.8352L20.9102 14.1909C21.3633 12.3346 21.3633 10.392 20.9102 8.53578L19.453 8.89148ZM15.0798 17.8651C13.5155 18.2177 11.8959 18.2177 10.3316 17.8651L10.0017 19.3284C11.7832 19.73 13.6282 19.73 15.4096 19.3284L15.0798 17.8651ZM10.3316 4.86154C11.8959 4.50892 13.5155 4.50892 15.0798 4.86154L15.4096 3.39825C13.6282 2.99668 11.7832 2.99668 10.0017 3.39825L10.3316 4.86154ZM9.88435 17.7643C7.96997 17.3328 6.44241 15.8182 5.95838 13.8352L4.50116 14.1909C5.1157 16.7085 7.06608 18.6666 9.5545 19.2276L9.88435 17.7643ZM15.8568 19.2276C18.3453 18.6666 20.2956 16.7085 20.9102 14.1909L19.453 13.8352C18.9689 15.8182 17.4414 17.3328 15.527 17.7643L15.8568 19.2276ZM15.527 4.96234C17.4414 5.39388 18.9689 6.90847 19.453 8.89148L20.9102 8.53578C20.2956 6.01813 18.3453 4.05999 15.8568 3.49906L15.527 4.96234ZM9.5545 3.49906C7.06607 4.05999 5.1157 6.01813 4.50116 8.53578L5.95838 8.89147C6.44241 6.90847 7.96997 5.39388 9.88435 4.96234L9.5545 3.49906ZM5.66602 15.4586H19.7453V13.9586H5.66602V15.4586ZM5.33541 5.74609L5.46979 6.48034L6.94528 6.21031L6.8109 5.47605L5.33541 5.74609ZM3.36819 3.73833C4.35153 3.91388 5.14482 4.70471 5.33541 5.74609L6.8109 5.47605C6.51183 3.8419 5.25386 2.55125 3.63181 2.26167L3.36819 3.73833Z" />
                                    <Path d="M14 7L14.0408 7.00583C15.7484 7.24978 17 8.51614 17 10" stroke="#9F6ABB" stroke-width="1.5" stroke-linecap="round"/>
                                    </svg> */}
                                    <svg xmlns="http://www.w3.org/2000/svg" width={isSoSmall?"18":"24"} height={isSoSmall?"18":"24"} viewBox="0 0 24 24" fill="none">
                                        <path className="path-nav-fill" d="M8.57463 16.9917H20.2969C20.6882 16.9917 21.0298 16.6703 21.0298 16.2383C21.0298 15.8063 20.6882 15.4849 20.2969 15.4849H8.7452C8.17263 15.4849 7.8212 15.0829 7.73077 14.4704L7.57006 13.4157H20.3166C21.7832 13.4157 22.5366 12.5114 22.7475 11.0753L23.5511 5.76143C23.5724 5.63524 23.5858 5.50786 23.5913 5.38C23.5913 4.89786 23.2296 4.56614 22.6772 4.56614H6.27449L6.08335 3.29071C5.98306 2.51714 5.70192 2.125 4.67763 2.125H1.15135C0.749775 2.125 0.408203 2.47729 0.408203 2.87929C0.408203 3.29071 0.749775 3.64257 1.15177 3.64257H4.54649L6.15363 14.6714C6.36492 16.0977 7.11792 16.9917 8.57463 16.9917ZM21.8835 6.08286L21.1712 10.8944C21.0906 11.5171 20.7593 11.899 20.1666 11.899L7.34977 11.9089L6.49563 6.08286H21.8835ZM9.36835 21.8736C9.58254 21.8753 9.79494 21.8345 9.99317 21.7533C10.1914 21.6722 10.3715 21.5524 10.523 21.4009C10.6744 21.2494 10.7942 21.0693 10.8754 20.8711C10.9565 20.6729 10.9974 20.4605 10.9956 20.2463C10.9965 20.0323 10.9551 19.8203 10.8736 19.6225C10.7922 19.4246 10.6723 19.2449 10.521 19.0936C10.3697 18.9423 10.19 18.8225 9.99215 18.741C9.79431 18.6596 9.5823 18.6181 9.36835 18.619C8.45463 18.619 7.7312 19.3424 7.7312 20.2463C7.7312 21.1604 8.45463 21.8736 9.36835 21.8736ZM18.7601 21.8736C19.6742 21.8736 20.3972 21.1604 20.3972 20.2463C20.3972 19.342 19.6742 18.619 18.7601 18.619C17.8562 18.619 17.1229 19.3424 17.1229 20.2463C17.1229 21.1604 17.8562 21.8736 18.7601 21.8736Z" />
                                    </svg>
                            </Badge>
                            </Box>
                        
                        {/* </IconButton> */}
                    </Tooltip>
                </Box>
                
                
        </ItemList>
            }else{
                return<ItemList key={`Menu_${e.name}`}>
                <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' ,marginRight:"-7px",
                    "@media(max-width:600px)":{
                        marginRight:"0"
                    }}}>
                    <Tooltip  title={e.name} >
                        <Box onClick={()=>{
                            if(e.name == "Wishlist")
                            navigate("/wishlist")
                        }}
                        sx={{padding:"0 !important",
                        "& .path-nav-fill":{
                            fill:"grey",
                            transition:"0.3s"
                          },
                          "&:hover":{
                            cursor:"pointer",
                              "& .path-nav-fill":{
                                fill:"#D80621"
                              }
                            }
                    
                    }}
                        size="small"
                        
                        >
                        <Avatar    
                            sx={isSoSmall?{background:"white", width: 18, height: 18}:{background:"white", width: 32, height: 32 }}>
                        <svg  xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path className="path-nav-fill" d="M16.6875 3C14.7516 3 13.0566 3.8325 12 5.23969C10.9434 3.8325 9.24844 3 7.3125 3C5.77146 3.00174 4.29404 3.61468 3.20436 4.70436C2.11468 5.79404 1.50174 7.27146 1.5 8.8125C1.5 15.375 11.2303 20.6869 11.6447 20.9062C11.7539 20.965 11.876 20.9958 12 20.9958C12.124 20.9958 12.2461 20.965 12.3553 20.9062C12.7697 20.6869 22.5 15.375 22.5 8.8125C22.4983 7.27146 21.8853 5.79404 20.7956 4.70436C19.706 3.61468 18.2285 3.00174 16.6875 3ZM12 19.3875C10.2881 18.39 3 13.8459 3 8.8125C3.00149 7.66921 3.45632 6.57317 4.26475 5.76475C5.07317 4.95632 6.16921 4.50149 7.3125 4.5C9.13594 4.5 10.6669 5.47125 11.3062 7.03125C11.3628 7.16881 11.4589 7.28646 11.5824 7.36926C11.7059 7.45207 11.8513 7.49627 12 7.49627C12.1487 7.49627 12.2941 7.45207 12.4176 7.36926C12.5411 7.28646 12.6372 7.16881 12.6937 7.03125C13.3331 5.46844 14.8641 4.5 16.6875 4.5C17.8308 4.50149 18.9268 4.95632 19.7353 5.76475C20.5437 6.57317 20.9985 7.66921 21 8.8125C21 13.8384 13.71 18.3891 12 19.3875Z" />
                        </svg>
                        </Avatar>
                        </Box>
                    </Tooltip>
            </Box>
                
                
        </ItemList>
            }
            
        })}
        <Drawer
            anchor={"right"}
            open={isDrower}
            onClose={()=>{setIsDrower(false)}}
          >
            <Side_Bar onClose={()=>{setIsDrower(false)}} />
          </Drawer>
        {localStorage.hasOwnProperty("user")&&<NotificationMenu />}
        
        
        {(isNav&& (user.username.length==0))&&<ItemList style={{display:"flex",gap:"10px"}}>
            
            <Button  onClick={()=>{window.location.href="/autherization";}}>
                {!isSmallForButtons &&<Icon style={{display:"flex"}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 24 24" fill="none">
                        <path d="M2.00195 11.998H16.002M16.002 11.998L12.502 8.99805M16.002 11.998L12.502 14.998" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M9.00391 7C9.01591 4.825 9.11291 3.647 9.88091 2.879C10.7599 2 12.1739 2 15.0019 2H16.0019C18.8309 2 20.2449 2 21.1239 2.879C22.0019 3.757 22.0019 5.172 22.0019 8V16C22.0019 18.828 22.0019 20.243 21.1239 21.121C20.2439 22 18.8309 22 16.0019 22H15.0019C12.1739 22 10.7599 22 9.88091 21.121C9.11291 20.353 9.01591 19.175 9.00391 17" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
                        </svg>
                </Icon>}
                
                Login
            </Button>
            <Button  onClick={()=>{window.location.href="/register";}}>
                {!isSmallForButtons&&<Icon style={{display:"flex"}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 24 24" fill="none">
                        <path d="M2.00195 11.998H16.002M16.002 11.998L12.502 8.99805M16.002 11.998L12.502 14.998" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M9.00391 7C9.01591 4.825 9.11291 3.647 9.88091 2.879C10.7599 2 12.1739 2 15.0019 2H16.0019C18.8309 2 20.2449 2 21.1239 2.879C22.0019 3.757 22.0019 5.172 22.0019 8V16C22.0019 18.828 22.0019 20.243 21.1239 21.121C20.2439 22 18.8309 22 16.0019 22H15.0019C12.1739 22 10.7599 22 9.88091 21.121C9.11291 20.353 9.01591 19.175 9.00391 17" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
                        </svg>
                </Icon>}
                
                Register
            </Button>
        </ItemList>}
        {user.username.length>0 &&<ItemList style={{marginLeft:"5px"}}>
            <Icon style={{marginLeft:"-20px"}}>
                <AccountMenu userName={user.username} photo={user.photo} name="account" />
            </Icon>
        </ItemList>}

             { localStorage.hasOwnProperty("user") && <li className="menu_li">
                <Tooltip title={balance}>
                    <MarqueeBox onClick={()=>{ navigate(`/profile/${JSON.parse(localStorage.getItem("user")).username}/balance`)}}>    
                        <marquee behavior="scroll" direction="left" scrollamount="1">{balance}</marquee>
                    </MarqueeBox>
                </Tooltip>
                    
                </li>}

    </List>:<ListHref>
        {data.map((e,index)=>{
            
            return<ItemList key={`Link_${e.name}`}>
            <IconFooter>
            {e.icon}
            </IconFooter>
            <Link style={{textDecoration: "none"}} target="_blank" to={e.href}>
                <LinkFooter>
                {e.name}
                </LinkFooter>
            </Link>
        </ItemList>
        })}

        

    </ListHref> );
}
const mapStateToProps = (state)=>{
    return{
        username:state.username,
        photo:state.photo,
        balance_redux:state.balance,
        number_Redux:state.number,
        isOpen:state.isOpen
    }
}
const mapDispatchToState = (dispatch)=>{
    return{
        cart_with_api: (cart,balance)=>{dispatch(get_cart(cart,balance))},
        cart_number : (number)=>{dispatch(notification_Cart(number))},
        change_balance :(balance)=>{dispatch(change_balance(balance))}
    }
}

export default connect(mapStateToProps,mapDispatchToState)(MDMenu);